module.exports = __webpack_public_path__ + "img/c6147093b1fc6ae924f29fb6a368ff64.png";